// extracted by mini-css-extract-plugin
export var centerAligned = "n7DjEWGALnIFY0ZEGXSc";
export var info = "ZM9wRqhqZEOjFQyyap5F";
export var leftBorder = "iOUAaPZoO2JX6NjpuIjp";
export var negative = "yY5Doy4cc9e3gobNWtTa";
export var neutral = "PHdZkiKGmqCZaYR4dgzU";
export var positive = "AaiMy2_BNG6GbBtreF4y";
export var primary = "KBmJiLfz45H14wTeFh8s";
export var root = "JDI4w_Jiq0PUzZgOslPI";
export var secondary = "T7Pq_TCk3hstlojbykHo";
export var title = "wR28mXsGQGu39lv6PMaV";
export var warning = "MX4Db7WzvK6JlGUejvIC";
export var withChevron = "vMl6c23lA06VBxqbDvet";